export default __webpack_public_path__ + "static/media/nucleo-icons.4466aeec.ttf";